import { fetchDataSet } from 'js/actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { tryCatchAsync } from 'new/utils/TryCatch';

type UseDataSetAdapter = {
  requestDataSetById(id: number): any;
  updateDataSet(id: number, payload: any): any;
};

export function useDataSetAdapter(): UseDataSetAdapter {
  const dispatch = useDispatch<any>();

  const requestDataSetById = useCallback(
    async (dataSetId: number): Promise<any> => {
      const request = dispatch(fetchDataSet(dataSetId));
      const { error, data } = await tryCatchAsync(request);

      if (error) throw new Error(error?.message);

      return data.entities.dataSets[dataSetId];
    },
    [dispatch],
  );

  const updateDataSet = useCallback(
    async (dataSetId: number, payload: any): Promise<any> => {
      const request = dispatch(fetchDataSet(dataSetId));
      const { error, data } = await tryCatchAsync(request);

      if (error) throw new Error(error?.message);

      return data.entities.dataSets[dataSetId];
    },
    [dispatch],
  );

  return { requestDataSetById, updateDataSet };
}
